import * as React from 'react';
import './index.css';
import { i18nClient } from '@sailor/i18n-mach-pro';
import ImageGridView from '@/src/components/ImageGridView';
import { ImageGridMode } from '@/src/components/ImageGridView/types';
import { ProductClickType, ReviewsProduct } from '../../order_review/component';

const starList = new Array(5).fill(false);

interface IProps {
  anonymousToShop: number;
  orderCommentScore: number;
  orderCommentScoreDesc: string;
  comment: string;
  reviewsReplyList?: Array<any>;
  shopCommentLabelList: {
    code: number;
    name: string;
  }[];
  pictureList: string[];
  reviewsProductList: ReviewsProduct[];
  reviewsFlag?: number;
  remindDescList?: string[];
}

interface IState {
  hasPicList: boolean;
}

export default class extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      hasPicList: props.pictureList && props.pictureList.length > 0,
    };
  }

  componentDidUpdate(prevProps: IProps) {
    if (prevProps.pictureList !== this.props.pictureList) {
      this.setState({
        hasPicList: this.props.pictureList && this.props.pictureList.length > 0,
      });
    }
  }

  renderImages = () => {
    const { pictureList } = this.props;
    const { hasPicList } = this.state;

    // let hasPicList = pictureList && pictureList.length > 0;

    return (
      hasPicList && (
        <view className="image-container">
          <ImageGridView initialImages={pictureList} mode={ImageGridMode.BROWSE} />
        </view>
      )
    );
  };

  renderProductsTags = () => {
    const { reviewsProductList } = this.props;
    const likeIcon = 'assets://review/icon_review_like_light.png';
    const unLikeIcon = 'assets://review/icon_review_unlike_light.png';

    if (!reviewsProductList || reviewsProductList.length === 0) {
      console.log('reviewsProductList 为空');
      return null;
    }

    const likedProudcts = reviewsProductList.filter((item) => item?.clickType === ProductClickType.CLICK_LIKE);
    const dislikedProudcts = reviewsProductList.filter((item) => item?.clickType === ProductClickType.CLICK_UNLIKE);

    const hasLikedProducts = likedProudcts.length > 0;
    const hasDislikedProducts = dislikedProudcts.length > 0;

    const likeTitle = i18nClient.getText('review_liked');
    const dislikeTitle = i18nClient.getText('review_disliked');

    return (
      <view className="product_review_container">
        {hasLikedProducts && this.renderProductLikeItem(likeIcon, likeTitle, likedProudcts)}
        {hasDislikedProducts && this.renderProductLikeItem(unLikeIcon, dislikeTitle, dislikedProudcts)}
      </view>
    );
  };

  renderProductLikeItem = (iconUrl, tagTitle, products: ReviewsProduct[] = []) => {
    const productsName = products.map((item) => item?.name ?? '').join(', ');
    const { hasPicList } = this.state;

    return (
      <view className={`product_review_item ${hasPicList ? 'mt12' : 'mt2'}`}>
        <view className="product_review_icon_container">
          <image className="product-review-icon" src={iconUrl} />
          <text className="product-review-title" content={`${tagTitle}:`} />
        </view>
        <text className="product-review-names" content={productsName} />
      </view>
    );
  };

  renderDisplayImagesTip = () => {
    const { reviewsFlag, remindDescList } = this.props;
    const hasRemindDesc = reviewsFlag === 0 && remindDescList && remindDescList.length > 0;
    const remindDesc = remindDescList && remindDescList[0];

    return (
      hasRemindDesc && (
        <view className="tail-wrap">
          <image className="image-display-icon" src="assets://review/icon_info.png" />
          <text className="image-display-desc" content={remindDesc} />
        </view>
      )
    );
  };

  render() {
    const {
      anonymousToShop,
      orderCommentScore,
      orderCommentScoreDesc,
      reviewsReplyList = [],
      comment,
      shopCommentLabelList = [],
    } = this.props;
    return (
      <view className="shop-card">
        <view className="top-wrap">
          <view className="top-left">
            <image className="icon" src="assets://review/rc_shop.png" />
            <text className="title" content={i18nClient.getText('reviews_to_restaurant')} />
          </view>
          {anonymousToShop === 1 && <text className="subtitle" content={i18nClient.getText('reviews_anonymous')} />}
        </view>
        <view className="bottom-wrap">
          <view className="bottom-top">
            {/* star list */}
            <view className="star-wrap">
              {starList.map((item, index) => {
                const selected = Number(orderCommentScore) - 1 >= index;
                return (
                  <image
                    key={index}
                    className="icon-star"
                    src={
                      selected
                        ? 'assets://review/icon_review_res_star_selected.png'
                        : 'assets://review/icon_review_res_star_normal.png'
                    }
                  />
                );
              })}
            </view>
            <text className="bottom-title" content={orderCommentScoreDesc} />
          </view>
          {comment && <text className="text" content={comment} />}
          {shopCommentLabelList.length ? (
            <view className="label-wrap">
              {shopCommentLabelList.map((item) => (
                <text key={item.code} className="label-item" content={item.name} />
              ))}
            </view>
          ) : null}
          {reviewsReplyList?.length && (
            <view className="reply-card">
              <view className="reply-top">
                <text className="reply-top-title" content={reviewsReplyList?.[0]?.replyDesc} />
                <view className="reply-top-point" />
                <text className="reply-top-time" content={reviewsReplyList?.[0]?.replyTimeText} />
              </view>
              <text className="reply-text" content={reviewsReplyList?.[0]?.comment} />
            </view>
          )}
          {this.renderImages()}
          {this.renderProductsTags()}
        </view>
        {this.renderDisplayImagesTip()}
      </view>
    );
  }
}
